// extracted by mini-css-extract-plugin
export default {"horizontalLine":"styles_horizontalLine__Nzplv"};